<template>
  <section>
    {{item.value}}
    <span v-show="item.edited == '1'">
      <div class="editForm">
        <table class="table">
          <thead v-if="item.headers.length != 0">
            <th v-for="(object,index) in item.headers" :key="`headers-${index}`"
              v-bind:class="{ 'small-width': isSmall(object.width) }">{{object.title}}</th>
          </thead>
          <tbody>
            <tr v-for="(object,index) in item.columns" :key="`row-${index}`">
              <td
                v-bind:class="{ title: isTitle(childObject) }"
                v-for="(childObject,childIndex) in object.items"
                :key="`row${index}-item${childIndex}`"
              >
                <span v-if="childObject.type == 'title'">{{childObject.text}}</span>
                <span v-if="childObject.type == 'info'">{{childObject.text}}</span>                
                <span v-if="childObject.type == 'input'">{{childObject.text}}</span>
                <span v-if="childObject.type == 'checkbox'">
                  <i
                    class="fal fa-check-square"
                    v-if="childObject.value == '1'"
                  />
                  <i class="fal fa-square" v-if="childObject.value == '0'" />
                  {{childObject.text}}
                </span>

                <span v-if="childObject.type == 'yesno'">
                  {{ getYesNo(childObject.value) }}
                </span>
                
                <nl2br
                  tag="span"
                  v-if="childObject.type == 'text'" :text="childObject.text"
                ></nl2br>
              </td>
            </tr>
          </tbody>
        </table>
        <i
          class="fal fa-times-circle"
          @click="removeEdit"
          v-b-tooltip.hover
          :title="$t('TEMPLATE.FORM.REMOVE')"
        />
      </div>
    </span>
    <b-card no-body v-show="item.edited == '0'" class="mt-2">
      <b-card-body>
        <table class="table">
          <thead v-if="item.headers.length != 0">
            <th v-for="(object,index) in item.headers" :key="`headers-${index}`"
            v-bind:class="{ 'small-width': isSmall(object.width) }">{{object.title}}</th>
          </thead>
          <tbody>
            <tr v-for="(object,index) in item.columns" :key="`row-${index}`">
              <td
                v-for="(childObject,childIndex) in object.items"
                v-bind:class="{ title: isTitle(childObject) }"
                :key="`row${index}-item${childIndex}`"
              >
                <span v-if="childObject.type == 'title'">{{childObject.text}}</span>
                <span v-if="childObject.type == 'info'">{{childObject.text}}</span>
                <b-form-input
                  v-if="childObject.type == 'input'"
                  v-model="childObject.text"
                ></b-form-input>
                <b-form-checkbox
                  v-if="childObject.type == 'checkbox'"
                  v-model="childObject.value"
                  value="1"
                  unchecked-value="0"
                >{{childObject.text}}</b-form-checkbox>
                <b-form-checkbox
                  v-if="childObject.type == 'yesno'"
                  v-model="childObject.value"
                  value="1"
                  unchecked-value="0"
                >{{childObject.text}}</b-form-checkbox>
                <b-form-textarea
                  v-if="childObject.type == 'text'"
                  rows="3"
                  max-rows="6"
                  v-model="childObject.text"
                ></b-form-textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </b-card-body>
      <b-card-footer>
        <b-form-text class="ml-2" v-if="typeof item.help !== 'undefined'">{{item.help[0].charkey}}</b-form-text>
        <b-button class="float-right mt-2 btn-fill" @click="saveForm">Save</b-button>
      </b-card-footer>
    </b-card>
  </section>
</template>
<script>
export default {
  props: ["value","templateId"],
  data() {
    return {
      item: this.value,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    saveForm: function() {
      let answers = this.getAnswers();
      let self = this;
      this.$http.post(process.env.VUE_APP_BACKEND + "/template/document/answer/update", {
        templateId: this.templateId,
        answers: answers
      })
      .then(function() {
        self.item.edited = "1";
      })
      .catch(function() {
        self.item.edited = "0";
        self.$noty.error(self.$t("ERROR.COULD_NOT_SAVE"));
      });
    },
    getYesNo(value){
      if(value == "1")
      {
        return "Yes";
      }else{
        return "No";
      }
    },    
    removeEdit: function() {
      this.item.edited = "0";
    },
    isTitle(object) {
      return object.type == "title";
    },
    isSmall(value) {
      return value == "small";
    },
    getAnswers()
    {
      let columns = this.item.columns;
      let answers = [];
      for (let ix = 0; ix < columns.length; ix++) {
        let parentObj = columns[ix];
        for (let jx = 0; jx < parentObj.items.length; jx++) {
          let childObject = parentObj.items[jx];
          if (childObject.type == "checkbox") {
            answers.push({
              key: childObject.id,
              value: childObject.value
            });
          }
          if (childObject.type == "text") {
            answers.push({
              key: childObject.id,
              value: childObject.text
            });
          }
          if (childObject.type == "input") {
            answers.push({
              key: childObject.id,
              value: childObject.text
            });
          }
          if (childObject.type == "yesno") {
            answers.push({
              key: childObject.id,
              value: childObject.value
            });
          }
        }
      }
      return answers;
    }
  },
  mounted() {
  }
};
</script>
<style>
</style>